<div class="content" fxLayout="column">
  <div fxLayout="column" *ngIf="loaded">
    <div fxLayout="row" class="subject" fxLayoutGap="10px">
      <div fxLayout="row" fxFlex="50px" class="subject-title" fxLayoutAlign="end">Subject:</div>
      <div fxLayout="row" fxFlex>
        <b [innerHTML]="data.subject | safeHtml"></b>
      </div>
    </div>

    <div fxLayout="row" class="subject" fxLayoutGap="10px">
      <div fxLayout="row" fxFlex="50px" class="subject-title" fxLayoutAlign="end">From:</div>
      <div fxLayout="column" fxLayout.gt-xs="row" fxLayoutGap="5px">
        <div fxLayout="row">
          <b>{{ data.senderName }}</b>
        </div>
        <div fxLayout="row" fxLayoutAlign="start">&lt;{{ data.sender }}&gt;</div>
      </div>
    </div>

    <div fxLayout="row" class="subject" *ngIf="data.replyTo" fxLayoutGap="10px">
      <div fxLayout="row" fxFlex="50px" class="subject-title" fxLayoutAlign="end">Reply To:</div>
      <div fxLayout="row" fxFlex>{{ data.replyTo }}</div>
    </div>

    <div fxLayout="row" class="subject" *ngIf="data.bccAddresses && data.bccAddresses.length > 0" fxLayoutGap="10px">
      <div fxLayout="row" fxFlex="50px" class="subject-title" fxLayoutAlign="end">BCC:</div>
      <div fxLayout="row" fxFlex>{{ data.bccAddresses[0] }}</div>
    </div>
  </div>

  <div
    class="container"
    fxLayout="column"
    fxLayoutAlign="center center"
    [ngStyle]="{ 'background-color': loaded ? 'white' : '' }"
  >
    <div class="loading" *ngIf="!(failed$ | async) && loaded == false">
      <img src="../assets/img/Lineup-Logo-black.svg" />
      <p>loading...</p>
    </div>
    <div fxFlex class="iframe-container" *ngIf="!(failed$ | async); else failed">
      <iframe sandbox="allow-same-origin" title="Email Content" width="100%" #iframe></iframe>
    </div>
    <ng-template #failed
      ><div class="failed"><h3>Content is not available</h3></div></ng-template
    >
  </div>

  <a class="close" (click)="close()" aria-label="Close preview email"><mat-icon>close</mat-icon></a>
</div>
